import { render, staticRenderFns } from "./PasswordsStep.vue?vue&type=template&id=5a2a492b&scoped=true"
import script from "./PasswordsStep.vue?vue&type=script&lang=js"
export * from "./PasswordsStep.vue?vue&type=script&lang=js"
import style0 from "./PasswordsStep.vue?vue&type=style&index=0&id=5a2a492b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a492b",
  null
  
)

export default component.exports